export default __webpack_public_path__ + "static/media/product-cart--white.28ac9a5b.svg";